module.exports = __webpack_public_path__ + "static/media/priconne.cbcb8dd1.png";